import Image from "next/image";
import sanitizeHtml from "sanitize-html";

import hourglass from "components/ui/assets/images/hourglass.svg";
import logo from "components/ui/assets/images/sonder-image-word-logo.svg";
import { Text } from "components/ui/source";

import styles from "./MaintenancePage.module.scss";

interface Props {
  heading: string;
  description: string;
  contactLine?: string;
}

const MaintenancePage = ({ heading, description, contactLine }: Props) => {
  return (
    <>
      <main className="content-container">
        <div className={styles.container}>
          <Image width={170} height={100} src={logo} alt="sonder" />
          <div className={styles.mainContent}>
            <Image width={150} height={150} src={hourglass} alt="hourglass" />
            <div className={styles.message}>
              <Text types={["headline3", "bolder", "align_center"]}>
                {!!heading ? (
                  <span
                    dangerouslySetInnerHTML={{ __html: sanitizeInput(heading) }}
                  />
                ) : (
                  "Performing system maintenance"
                )}
              </Text>
              <Text types={["body1", "align_center"]}>
                {!!description ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizeInput(description),
                    }}
                  />
                ) : (
                  "Our site is temporarily unavailable while we perform our scheduled site maintenance. Thank you for your patience and we will be back up in a couple of minutes."
                )}
              </Text>

              <Text types={["body1", "align_center"]}>
                {!!contactLine ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizeInput(contactLine),
                    }}
                  />
                ) : (
                  <>
                    In case of emergency, reach us at{" "}
                    <strong>reservations@sonder.com</strong> or{" "}
                    <strong>+1-617-300-0956</strong>
                  </>
                )}
              </Text>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MaintenancePage;

function sanitizeInput(input: string) {
  return input.length
    ? sanitizeHtml(input, {
        allowedTags: ["strong", "br"],
      })
    : "";
}
